<template>
  <div class="ticket-detail-back">
    <loading v-show="showLoading"></loading>
    <div v-show="!showLoading">

      <!--状态-->
      <div class="ticket-detail-logistics" v-if="orderDetail.price">
        <div class="ticket-detail-status">
          {{orderDetail.statusName}}
        </div>
        <div class="ticket-detail-price">
          实付金额
          <span>
            ¥{{orderDetail.price.totalPrice}}
          </span>
        </div>
      </div>
      <div v-if="ticketsQrCode" style="margin-left: 15px;margin-bottom: 15px;">
        <div style="font-size: 20px;font-weight: 700;margin-bottom: 5px;" > 凭「电子凭证」直接使用</div>
        <div style="font-size: 13px;">请到入园口闸机刷二维码入园</div>
      </div>
      <div v-if="ticketsQrCode" style="margin-bottom: 9.6px;text-align: center;" >
        <img :src="'data:image/jpeg;base64,'+this.ticketsQrCode.img"
 alt="">
      </div>
      <!--商品信息-->
      <div class="ticket-goods" v-for="(goods,index) in orderDetail.productList" :key="index">

        <div class="ticket-goods-each">
          <div class="ticket-goods-each-left" style="width: 17rem;font-weight: bold">
            {{goods.productName}}
          </div>
          <div class="ticket-goods-each-right text-right" style="width: 4rem">
            x{{goods.quantity}}
          </div>
        </div>

        <div class="ticket-goods-each" >
          <div class="ticket-goods-each-left">
            使用日期
          </div>
          <div class="ticket-goods-each-right text-right">
            {{travelDate}}
          </div>
        </div>

        <div class="ticket-goods-each border-bottom" style="line-height: normal;padding: 0.3rem">
          <div class="ticket-goods-each-left">
            使用方法
          </div>
          <div class="ticket-goods-each-right" v-html="goods.longDescription"></div>
        </div>

        <div class="ticket-goods-each">
          <div class="ticket-goods-each-left">
            入园地址
          </div>
          <div class="ticket-goods-each-right text-right">
            浙江湖州市安吉县天使大道1号
          </div>
        </div>

        <div class="ticket-goods-each">
          <div class="ticket-goods-each-left">
            入园时间
          </div>
          <div class="ticket-goods-each-right text-right">
            {{enterTime}}
          </div>
        </div>
<!--        <div class="ticket-goods-each">-->
<!--          <div class="ticket-goods-each-left">-->
<!--          </div>-->
<!--          <div class="ticket-goods-each-right text-right">-->
<!--            (夜公园开放时间：16:00-21:00)-->
<!--          </div>-->
<!--        </div>-->

        <!--<div class="ticket-goods-each">-->
          <!--<div class="ticket-goods-each-left">-->
            <!--退票规则-->
          <!--</div>-->
          <!--<div class="ticket-goods-each-right">-->
            <!--<div>-->
              <!--1. 门票未使用, 游玩日期当天17:00前申请退票, 无需支付手续费; 其他时间, 不可退票;-->
            <!--</div>-->
            <!--<div>-->
              <!--2. 过期票需在1天内与客服联系，否则默认放弃！改期只能改一次日期，改期后的商品不可退。-->
            <!--</div>-->
            <!--<div>-->
              <!--3. 特价门票不可退票，不可改签日期。-->
            <!--</div>-->
            <!--<div>-->
              <!--4. 不支持部分退。-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->

      </div>

      <!--取票信息-->
      <div class="ticket-goods" v-if="orderDetail.resultPartyMessage">

        <div class="ticket-goods-each">
          <div class="ticket-goods-each-left">
            取票信息
          </div>
        </div>

        <div class="ticket-goods-each">
          <div class="ticket-each-left">
            姓名
          </div>
          <div class="ticket-each-right">
            {{pickUpMessage.travelName}}
          </div>
        </div>

        <div class="ticket-goods-each">
          <div class="ticket-each-left">
            手机号
          </div>
          <div class="ticket-each-right">
            {{pickUpMessage.travelMobile}}
          </div>
        </div>

        <div class="ticket-goods-each">
          <div class="ticket-each-left">
            身份证
          </div>
          <div class="ticket-each-right">
            {{pickUpMessage.travelIdNo}}
          </div>
        </div>

      </div>

      <!--订单价格-->
      <div class="order-price-div" v-if="orderDetail.price">
        <div class="order-price-each">
          <div class="order-price-title">
            商品总价
          </div>
          <div class="order-price-value">
            ￥{{orderDetail.productCountPrice}}
          </div>
        </div>
        <div class="order-price-each">
          <div class="order-price-title">
            运费
          </div>
          <div class="order-price-value">
            ￥{{orderDetail.price.partyPrice}}
          </div>
        </div>
        <div class="order-price-each">
          <div class="order-price-title">
            立减
          </div>
          <div class="order-price-value">
            {{orderDetail.price.productPromoPrice}}
          </div>
        </div>
        <div class="order-price-each">
          <div class="order-price-title">
            实付款
          </div>
          <div class="order-price-value">
            ￥{{orderDetail.price.totalPrice}}
          </div>
        </div>
      </div>

      <!--订单信息-->
      <div class="ticket-detail">
        <div class="ticket-detail-each">
          <div>
            订单编号：{{orderDetail.orderId}}
          </div>
          <div>
            <button></button>
          </div>
        </div>
        <div class="ticket-detail-each">
          <div>
            下单时间：{{orderDetail.orderDate|formatDate}}
          </div>
        </div>
        <div class="ticket-detail-each" v-if="orderDetail.paymentMethod">
          <div>
            支付方式：{{orderDetail.paymentMethod.description}}
          </div>
        </div>
        <div class="ticket-detail-each">
          <div v-if="orderDetail.statusName!='待付款'">
          支付时间：{{orderDetail.paymentDate|formatDate}}
          </div>
        </div>
      </div>

    </div>

    <div class="ticket-detail-footer">
      <button class="order-list-button-choice" v-if="orderDetail.statusName=='待付款'" @click.stop="goPay(orderDetail.orderId,orderDetail.price.totalPrice)">立即付款</button>
      <button class="order-list-button-noChoice" v-if="orderDetail.statusName=='待付款'" @click.stop="goCanel(orderDetail.orderId)">取消订单</button>
    </div>

  </div>
</template>

<script>

  import Vue from 'vue'
  import { storeName,prodCatalogId,shareOnlineUrl ,paymentUrl} from '@/router/Constant'
  import { getOrderInfo,orderCancel,confirmOrderRecive,weixinPays,cloudPays} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,Dialog} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';

  export default {
    name: "orderDetailTicket",
    data(){
        return{
          showLoading:true,
          orderId:this.$route.query.orderId,
          status:this.$route.query.status,
          statusName:this.$route.query.statusName,
          productStoreId:this.$route.query.productStoreId,
          token:getStore('externalLoginKey'),
          orderDetail:{},
          payMap:{},
          travelDate:"",
          ticketsQrCode:'',
          enterTime:"",
          pickUpMessage:{}
        }
      },
    mounted(){
        document.documentElement.scrollTop = 0
        this.showLoading = false
        this.initData()
      },
    components:{
        [NavBar.name]: NavBar,
        [Image.name]: Image,
        [Grid.name]: Grid,
        [Tabbar.name]: Tabbar,
        [Toast.name]: Toast,
        loading,
        [Dialog.Component.name]: Dialog.Component,
      },
    filters: {
        formatDate: function (value) {
          if(value!=null&&value!=''&&value!=undefined ){
            let date = new Date(value)
            let y = date.getFullYear()
            let MM = date.getMonth() + 1
            MM = MM < 10 ? ('0' + MM) : MM
            let d = date.getDate()
            d = d < 10 ? ('0' + d) : d
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d+'  '+h+':'+m
          }else{
            return ''
          }
        }
      },
    methods:{
        async initData() {
          this.getOrderDetail();
        },

        getOrderDetail:function () {
          let params = {
            statusName:this.statusName,
            orderId:this.orderId,
            status:this.status,
            externalLoginKey:this.token,
            productStoreId:this.productStoreId,
          }
          getOrderInfo(params)
            .then(res => {
              console.log(res);
              if(res._ERROR_MESSAGE_==undefined){
                this.orderDetail = res.orderList[0]
                this.travelDate = res.travelDate
                this.pickUpMessage = res.pickUpMessage
                if (res.ticketsQrCode) {
                  this.ticketsQrCode=res.ticketsQrCode
                  if (res.ticketsQrCode.code!='0') {
                  return  Toast(res.ticketsQrCode.description)
                  }
                }
                this.enterTime = res.enterTime
              }else{
                return  Toast(res._ERROR_MESSAGE_)
              }
            })
            .catch(err => {
              console.log(err);
            });
        },

        //跳转至评价页面
        goEval:function (orderId,goodsId,goods,orderItemSeqId) {
          setStore("goods",goods)
          this.$router.push({name:'orderEvaluation',query:{orderId:orderId,productId:goodsId,orderItemSeqId:orderItemSeqId}})
        },

        ztp(value){
          if (typeof value === "string") {
          // 复制某条消息
          if (!value) return; // console.log(data.string) // 正则表达式判断data是否是base64
          function validDataUrl(s) {
            return validDataUrl.regex.test(s);
          }
          validDataUrl.regex =
            /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i; // 如果是base64转换成图片预览
          if (validDataUrl(value)) {
            // debugger;
            let that = this;
            function previwImg(item) {
              that.imageUrl = item;
            }
            previwImg(value);
          }
        }
        },

        // 用户支付
        goPay:function (orderId,totalPrice) {
          Dialog.confirm({
            title: '支付订单',
            message: '确认要支付该订单吗?'
          }).then(() => {
            console.log(paymentUrl+'?orderId='+orderId+'&totalPrice='+totalPrice+'&externalLoginKey='+getStore('externalLoginKey'))
            wx.miniProgram.navigateTo({url:paymentUrl+'?orderId='+orderId+'&totalPrice='+totalPrice+'&externalLoginKey='+getStore('externalLoginKey')})

            // let params = {
            //   orderId:orderId,
            //   externalLoginKey:this.token
            // }
            // weixinPays(params)
            //   .then(res => {
            //     console.log(res);
            //     if(!res._EVENT_MESSAGE_){
            //
            //       // this.scanCode = res.scanCode
            //       // console.log("scanCode========="+this.scanCode)
            //       // window.location.href = this.scanCode
            //
            //
            //       this.payMap = res.payMap
            //       if (typeof WeixinJSBridge == "undefined"){
            //         if( document.addEventListener ){
            //           document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false);
            //         }else if (document.attachEvent){
            //           document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady());
            //           document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady());
            //         }
            //       }else{
            //         this.onBridgeReady();
            //       }
            //     }else{
            //       Toast({message:'获取参数失败'})
            //     }
            //
            //   })
            //   .catch(err => {
            //     this.showLoading = false
            //     console.log(err);
            //   });
          }).catch(() => {
            // on cancel
          });

        },

        //支付参数获取成功后掉取方法
        onBridgeReady:function(){
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', {
              "appId":this.payMap.appId,     //公众号名称，由商户传入
              "timeStamp":this.payMap.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":this.payMap.nonceStr, //随机串
              "package":this.payMap.package,
              "signType":this.payMap.signType,         //微信签名方式：
              "paySign":this.payMap.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ){
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                Toast({message:'支付成功'})
                // window.location.href = "https://dms.hellokittypark.cn/#/orderList"
                setTimeout(() => {
                  window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
                }, 3000);
                this.$router.back(-1)
              }else if(res.err_msg == "get_brand_wcpay_request:cancel"){
                Toast({message:'取消成功'})
                // window.location.href = "https://dms.hellokittypark.cn/#/orderList"
                setTimeout(() => {
                  window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
                }, 3000);
              }else if(res.err_msg == "get_brand_wcpay_request:fail"){
                Toast({message:'支付失败'})
                setTimeout(() => {
                  window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
                }, 3000);
              }
            });
        },

        //用户取消订单
        goCanel:function (orderId) {
          Dialog.confirm({
            title: '取消订单',
            message: '确认要取消该订单吗?'
          }).then(() => {
            let params = {
              productStoreId:this.productStoreId,
              orderId:orderId,
              externalLoginKey:this.token
            }
            orderCancel(params)
              .then(res => {
                console.log(res);
                if(res._EVENT_MESSAGE_!=undefined||res._EVENT_MESSAGE_!=null){
                  Toast(res._EVENT_MESSAGE_)
                }else{
                  Toast('取消订单成功')
                  this.$router.back(-1)
                }
              })
              .catch(err => {
                console.log(err);
              });
          }).catch(() => {
            // on cancel
          });

        },

        formatDate(value) {
          if(value!=null&&value!=''&&value!=undefined ){
            let date = new Date(value)
            let y = date.getFullYear()
            let MM = date.getMonth() + 1
            MM = MM < 10 ? ('0' + MM) : MM
            let d = date.getDate()
            d = d < 10 ? ('0' + d) : d
            return y + '.' + MM + '.' + d
          }else{
            return ''
          }
        },
      }
  }
</script>

<style>
  .ticket-detail-back{
    background-color: #F8F8F8;
  }

  .ticket-detail-logistics{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
    height: 4.6875rem;
  }

  .ticket-detail-status{
    font-size: 1.0625rem;
    color:#333333;
    margin-top: 0.9375rem;
    margin-left: 1rem;
    margin-bottom: 0.875rem;
  }
  .ticket-detail-price{
    font-size: 0.8125rem;
    color:#666;
    margin-left: 1rem;
  }
  .ticket-detail-price span{
    color:#EB84AB;
    font-size:0.875rem;
  }

  .order-price-div{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .order-price-each{
    width:21.4375rem;
    border-bottom: 1px solid #E7E7E7;
    margin: 0 auto;
    height: 2.65625rem;
    line-height: 2.65265rem;
    font-size: 0.84375rem;
    color:#333312;
    background-color: white;
  }
  .order-price-title{
    float: left;
  }
  .order-price-value{
    float: right;
  }
  .ticket-detail{
    width:100%;
    background-color: white;
    margin-bottom: 3.75rem;
  }
  .ticket-detail-each{
    width:21.4375rem;
    margin: 0 auto;
    background-color: white;
    height: 2rem;
    line-height: 2rem;
  }
  .ticket-detail-each div{
    font-size: 0.78125rem;
    color:#33312E;
  }
  .ticket-detail-footer{
    width:100%;
    position: fixed;
    bottom: 0;
    z-index: 99;
    background-color: white;
    border-top: 1px solid #E7E7E7;
    height: 3.75rem;
    line-height: 3.75rem;
  }
  .ticket-detail-footer button{
    width:5rem;
    height: 1.875rem;
    line-height: 1.875rem;
    border-radius: 0.9375rem;
    float: right;
    margin-right: 1rem;
    margin-top: 0.9375rem;
    font-size: 0.84375rem;
    text-align: center;
    padding: 0;
  }
  .order-list-button-choice{
    border: 1px solid #EB84AB;
    color:#EB84AB;
  }
  .order-list-button-noChoice{
    border: 1px solid #9E9E9E;
    color:#9E9E9E;
  }
  .ticket-goods{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .ticket-goods-each{
    width: 21.4375rem;
    /*height:2rem;*/
    line-height: 2rem;
    margin: 0 auto;
  }
  .ticket-goods-each-left{
    display: inline-block;
    vertical-align: top;
    color:#333;
    font-size: 0.8125rem;
    width:4rem;
  }
  .ticket-goods-each-right{
    /*float: right;*/
    color:#666;
    font-size: 0.75rem;
    display: inline-block;
    vertical-align: top;
    width:calc(100% - 4.5rem)
  }
  .text-right{
    text-align: right;
  }
  .ticket-each-left{
    display: inline-block;
    vertical-align: top;
    width:3rem;
    color:#333;
    font-size: 0.8125rem;
  }
  .ticket-each-right{
    display: inline-block;
    vertical-align: top;
    color:#666;
    font-size: 0.75rem;
    text-align: right;
  }
  .border-bottom{
    border-bottom: 1px solid #E7E7E7;
  }



</style>



// WEBPACK FOOTER //
// src/components/page/mine/orderDetailTicket.vue